import { fromNestedArguments } from './base';
export function tokenConst(data, tokenOptions) {
  var token = function token() {
    return data;
  };
  token.tokenOptions = tokenOptions;
  return token;
}
export function tokenFromNestedArguments(rawData, argList, tokenOptions) {
  return fromNestedArguments(function (a) {
    return a;
  }, rawData, argList, tokenOptions);
}
//# sourceMappingURL=simple.js.map